import React from "react";
import { NothingToSeeHere } from "@8x8/oxygen-graphics";
import { isRouteErrorResponse, Link, useRouteError } from "react-router-dom";
import styled from "styled-components";
import Button from "@8x8/oxygen-button";
import { OAuthError } from "@okta/okta-auth-js";
import { getEnv } from "@/env";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

export const ErrorBoundary = () => {
  const error = useRouteError();
  console.error(error);

  if (isRouteErrorResponse(error)) {
    return (
      <Container>
        <p>
          <NothingToSeeHere />
        </p>
        <h5>
          <i>{error.status}</i> {error.statusText}
        </h5>
        <p>
          <i>{error.data?.message || error.data}</i>
        </p>
        <Link to={-1}>
          <Button variant={"tertiary"}>Back</Button>
        </Link>
      </Container>
    );
  }

  // Okta errors
  if (error instanceof OAuthError) {
    const isNotAssignedError = error.errorCode === "access_denied";
    return (
      <Container>
        <p>
          <NothingToSeeHere />
        </p>
        <h5>Authentication Error</h5>
        <p>
          <i>
            {isNotAssignedError
              ? "You don't have access to this app"
              : error.toString()}
          </i>
        </p>
        {isNotAssignedError && (
          <Link to={getEnv("VUE_APP_IT_TICKET_URL")}>
            <Button variant={"tertiary"}>Request Access with IT Ticket</Button>
          </Link>
        )}
      </Container>
    );
  }

  return (
    <Container>
      <p>
        <NothingToSeeHere />
      </p>
      <h5>This is embarrassing...</h5>
      <p>
        <i>{error.message}</i>
      </p>
      <Link to={-1}>
        <Button variant={"tertiary"}>Back</Button>
      </Link>
    </Container>
  );
};
